
import React, { useState } from "react";
import { Dropdown } from "semantic-ui-react";
import "./Menu.css";
import { useAuth } from "../../lib/auth/useAuth";
import UploadVideoModal from "../UploadVideoModal";
import { useSelector } from 'react-redux';

export default function MenuTopBar({ activeCards, setActiveCards }) {
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const auth = useAuth();
  const allowedCards = useSelector(state => state.permissions.allowedCards);
  const hasPermission = (cardKey) => allowedCards.includes(cardKey);

  return (
    <>
      <div className={'topbar'} style={{ height: '40px', display: 'flex', alignItems: 'center' }}>
        <div className={'menu-container'} style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div className={'logo'} style={{ marginRight: '10px' }}>
              Dijon Dreams
            </div>
            {/* File menu removed */}
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {hasPermission('music_menu') && (
              <Dropdown direction={'left'} text='Music' className={'dropydown'}>
                <Dropdown.Menu>
                  <Dropdown.Item text='BBL Band' onClick={() => {
                    window.open('https://bbl.band', '_blank');
                  }} />
                </Dropdown.Menu>
              </Dropdown>
            )}
            {/* Popularity, Finance, and Backgammon tabs removed */}
            <a href="/blog" className="dropydown" style={{ color: 'white', paddingRight: '10px', paddingLeft: '10px', borderLeft: '1px solid', textDecoration: 'none', cursor: 'pointer' }}>
              Blog
            </a>
            {hasPermission('ledger') && (
              <a href="/ledger" className="dropydown" style={{ color: 'white', paddingRight: '10px', paddingLeft: '10px', borderLeft: '1px solid', textDecoration: 'none', cursor: 'pointer' }}>
                Ledger
              </a>
            )}
            <Dropdown direction={'left'} text='Account' className={'dropydown'}>
              <Dropdown.Menu>
                {auth.user ? (
                  <Dropdown.Item text='Logout' onClick={() => {
                    // Clear tokens and redirect to login
                    localStorage.removeItem('access_token');
                    localStorage.removeItem('refresh_token');
                    window.location.href = '/login';
                  }} />
                ) : (
                  <Dropdown.Item text='Login' href={'/login'} />
                )}
                <Dropdown.Divider />
                <Dropdown.Item text='Support' href="mailto: dijondreams@gmail.com" />
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>

      <UploadVideoModal
        open={uploadModalOpen}
        onClose={() => setUploadModalOpen(false)}
        onUploadSuccess={() => console.log('Video uploaded successfully!')}
      />
    </>
  );
}
